import React from 'react';

const Svg = (props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C14.4183 0 18 3.58172 18 8V13L19.8 15.4C20.1314 15.8418 20.0418 16.4686 19.6 16.8C19.4269 16.9298 19.2164 17 19 17H1C0.447715 17 0 16.5523 0 16C0 15.7836 0.0701779 15.5731 0.2 15.4L2 13V8C2 3.58172 5.58172 0 10 0ZM10 2C6.7616 2 4.12243 4.56557 4.00414 7.77506L4 8V13.6667L3 15H17.001L16 13.6667V8C16 4.68629 13.3137 2 10 2ZM10 20C11.1046 20 12 19.5523 12 19C12 18.4477 11.1046 18 10 18C8.89543 18 8 18.4477 8 19C8 19.5523 8.89543 20 10 20Z" fill="currentColor"/></svg>
);

export default Svg;
